export default "__VITE_ASSET__Cos5Mk6k__"